/**
 * Checks whether or not a value is a number.
 *
 * @param {any} value evaluate if number
 * @returns {boolean} isNumber
 */
export default function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}
